import React from "react";

export type IncidentRowExitVariant = "accept" | "reject";

const EXIT_DURATION_MS = 480;

export function useIncidentRowExit() {
  const [exitVariant, setExitVariant] =
    React.useState<IncidentRowExitVariant | null>(null);
  const timerRef = React.useRef<ReturnType<typeof setTimeout> | null>(null);

  React.useEffect(() => {
    return () => {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
    };
  }, []);

  const playExitAndThen = React.useCallback(
    (variant: IncidentRowExitVariant, action: () => void) => {
      setExitVariant(variant);
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
      timerRef.current = setTimeout(() => {
        action();
        setExitVariant(null);
      }, EXIT_DURATION_MS);
    },
    []
  );

  const rowClassName = exitVariant
    ? `incidents-row-exit incidents-row-exit--${exitVariant}`
    : "";

  return {
    exitVariant,
    rowClassName,
    isExiting: exitVariant !== null,
    playExitAndThen,
  };
}
